.blocks {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  margin-top: var(--space-8);
}

.person {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  align-items: start;
  column-gap: var(--space-3);
}

.disabled .name,
.disabled .facts {
  color: var(--label-3);
}

.who {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
}

.name {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  font: var(--text-headline);
  letter-spacing: var(--tracking-headline);
  color: var(--label);
}

.me {
  padding: 0 var(--space-1);
  border-radius: var(--radius-tag);
  background: var(--fill);
  font: var(--text-caption-1);
  color: var(--label-2);
}

.facts {
  font: var(--text-footnote);
  color: var(--label-2);
}

.manage {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--space-2);
}

.buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-1) var(--space-4);
}

.invite {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-2) var(--space-4);
}


.link {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-3);
  border-radius: var(--radius-list);
  background: var(--card-2);
}

.url {
  flex: 1 1 16ch;
  min-width: 0;
  font: var(--text-footnote);
  color: var(--label);
  overflow-wrap: anywhere;
  user-select: all;
}

@media (max-width: 719px) {
  .person {
    grid-template-columns: 22px minmax(0, 1fr);
    row-gap: var(--space-3);
  }

  .manage {
    grid-column: 2;
    align-items: flex-start;
  }

  .buttons {
    justify-content: flex-start;
  }
}

.clients {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  margin-bottom: var(--space-1);
  padding: 0;
  font: var(--text-footnote);
  font-weight: 600;
  color: var(--label-2);
}

.note {
  font: var(--text-footnote);
  color: var(--label-2);
  text-wrap: pretty;
}
